module.exports = __webpack_public_path__ + "img/adiat.720370c8.png";